import { Component, Input, ViewChild, TemplateRef, SimpleChanges, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CustomFieldsService } from '../../../services/custom-fields.service';
import { OverlayService, ModalDefinition } from '../../../services/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PublicationService } from '../../../services/publication.service';
import { Publication } from '../../../interfaces/publication';
import { LocationService } from '../../../services/location.service';

@Component({
	selector: 'mediaclip-details-metadata',
	templateUrl: './mediaclip-details-metadata.component.html',
	styleUrls: ['./mediaclip-details-metadata.component.scss']
})


export class MediaclipDetailsMetadataComponent implements OnInit, OnChanges, OnDestroy {
	@Input() mediaclip: any;
	@Input() form: NgForm;

	@ViewChild('qrcodeModal') qrcodeModal: TemplateRef<any>;

	customFields: any[] = [];
	useRichTextDescription = false;

	baseUrl: string;
	placeholder: string;
	qrCodeImageUrl: string;
	subUseTypeOptions = [{
		label: this.translate.instant('VAST_CREATIVE'),
		value: 'vast_creative'
	}];

	subscriptions: Subscription;

	constructor(
		private customFieldsService: CustomFieldsService,
		private overlayService: OverlayService,
		private publicationService: PublicationService,
		private locationService: LocationService,
		private translate: TranslateService
	) {
		this.subscriptions = new Subscription();

		this.subscriptions.add(
			this.publicationService.getData().subscribe((publication: Publication) => {
				if (publication) {
					this.baseUrl = publication.baseurl;
					this.useRichTextDescription = publication.richTextDescription === 'true';
				}
			})
		);
	}

	ngOnInit() {
		this.customFields = this.customFieldsService.getCustomFields('mediaclip');
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges && simpleChanges.mediaclip) {
			this.qrCodeImageUrl = `${this.locationService.server}/api/mediaclip/${this.mediaclip.id}-qrcode.png`;
			if (this.mediaclip.deeplink && this.mediaclip.deeplink.length > 0) {
				this.placeholder = '';
			} else if (this.mediaclip.id) {
				this.placeholder = `https:${this.baseUrl}/view/default/${this.mediaclip.id}.html?title=${this.mediaclip.title ? this.mediaclip.title : ''}`;
			} else {
				this.placeholder = '';
			}
		}
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	showQrCode() {

		const modal: ModalDefinition = {
			icon: 'qrcode',
			title: this.translate.instant('QR_CODE'),
			component: {
				name: 'custom-content',
				templateRef: this.qrcodeModal
			}
		};

		this.overlayService.createModal(modal);
	}

	log(a: any) {
		console.warn('log', a);
	}
}
